<a class="product-container" (click)="navigateToPolicy()">
  <div class="product-details">
    <span [ngClass]="iconType"></span>
    <div class="product-info">
      <div class="product-name">{{ productName }}</div>
    </div>
  </div>
</a>
